import { createIcon, IconColors } from './icon-utils';

export const NormalArrowDownIcon = createIcon({
  path: 'm9.23 10.777 5.15-4.917a.563.563 0 0 1 .778.813l-5.277 5.04a.94.94 0 0 1-1.3 0l-5.277-5.04a.563.563 0 0 1 .777-.813l5.15 4.917z',
  style: { color: IconColors.DarkGrey },
  viewBox: '0 0 18 18',
});
